import React from 'react';
import { ConfirmationModal } from '@tmobile/tmo-bps-syncup-web-component-lib';

/**
 * Presentational wrapper around the common <ConfirmationModal> component
 * — Used specifically for confirming IMEI CSV upload action.
 *
 * Props:
 *  - isOpen (boolean): Controls visibility of the modal
 *  - onConfirm (function): Called when user clicks "Upload"
 *  - onCancel (function): Called when user clicks "Cancel"
 *  - isLoading (boolean): When true, disables action buttons to prevent double-submit
 */
const IMEIConfirmationModal = ({ isOpen, onConfirm, onCancel, isLoading }) => (
  <ConfirmationModal
    // Controls whether the modal is visible on screen
    isOpen={isOpen}
    // Fired when confirmation ("Upload") button is clicked
    onAcceptBtnClicked={onConfirm}
    // Fired when the cancel ("Cancel") button is clicked
    onDenyBtnClicked={onCancel}
    // Disable buttons while upload is in progress to avoid multiple submissions
    buttonsDisabled={isLoading}
    // Title inside the modal dialog
    title="Are you sure you want to upload this CSV?"
    // Caption text for confirm button
    acceptBtnTitle="Upload"
    // Caption text for cancel button
    denyBtnTitle="Cancel"
    // Styling variant — "primary" shows main action emphasis
    modalType="primary"
  />
);

export default IMEIConfirmationModal;
